// WordPress Installer - jQuery implementation
// Uses existing OPSPI stack: jQuery + Bootstrap + ActionCable

// Global subscription to prevent duplicates on Turbolinks page changes
let wordpressDeploymentSubscription = null;

function initializeWordPressDeploymentChannel() {
  // Only subscribe once globally
  if (wordpressDeploymentSubscription) return;
  
  if (typeof consumer !== 'undefined') {
    wordpressDeploymentSubscription = consumer.subscriptions.create(
      { channel: "DeploymentChannel" },
      {
        received(data) {
          if (data.event === 'deployment.updated' && data.application === 'wordpress') {
            refreshWordPressCard(data.domain_id);
          }
        }
      }
    );
  }
}

$(document).ready(function() {
  // Initialize deployment channel if WordPress cards exist
  if ($('.wordpress-card').length > 0) {
    initializeWordPressDeploymentChannel();
  }
  
  // Handle Install WordPress button click
  $(document).on('click', '.wordpress-install-btn', function(e) {
    e.preventDefault();
    const $btn = $(this);
    const domainId = $btn.data('domain-id');
    const $card = $(`.wordpress-card[data-domain-id="${domainId}"]`);
    const installUrl = $card.data('install-url');
    
    // Disable button and show loading
    $btn.prop('disabled', true).html('<span class="spinner-border spinner-border-sm me-2"></span>Installing...');
    
    // Call install API
    $.ajax({
      url: installUrl,
      method: 'POST',
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      success: function(data) {
        // Immediately refetch state once
        refreshWordPressCard(domainId);
      },
      error: function(xhr) {
        // Safe error handling - no HTML injection
        const message = xhr.responseJSON?.error || 'WordPress installation could not be started';
        
        $card.find('.card-body')
          .empty()
          .append(
            $('<div>')
              .addClass('alert alert-danger')
              .text(message)
          );
        
        // Re-enable button
        $btn.prop('disabled', false).text('Install WordPress');
      }
    });
  });
  
  // Handle Reveal Credentials button click
  $(document).on('click', '.wordpress-reveal-credentials-btn', function(e) {
    e.preventDefault();
    const $btn = $(this);
    const domainId = $btn.data('domain-id');
    const $card = $(`.wordpress-card[data-domain-id="${domainId}"]`);
    const $credentialsContainer = $(`.wordpress-credentials[data-domain-id="${domainId}"]`);
    const credentialsUrl = $card.data('credentials-url');
    
    // Show loading
    $btn.prop('disabled', true).html('<span class="spinner-border spinner-border-sm me-2"></span>Loading...');
    
    // Call credentials API
    $.ajax({
      url: credentialsUrl,
      method: 'POST',
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      success: function(data) {
        // Build credentials display safely
        const $credBox = $('<div>')
          .addClass('card bg-light mt-3')
          .append(
            $('<div>').addClass('card-body').append(
              $('<h6>').addClass('card-title').text('Admin Credentials'),
              $('<div>').addClass('mb-2').append(
                $('<strong>').text('URL: '),
                $('<a>').attr({href: data.admin_url, target: '_blank', rel: 'noopener noreferrer'}).text(data.admin_url)
              ),
              $('<div>').addClass('mb-2').append(
                $('<strong>').text('Username: '),
                $('<code>').addClass('text-dark').text(data.admin_username)
              ),
              $('<div>').addClass('mb-0').append(
                $('<strong>').text('Password: '),
                $('<code>').addClass('text-dark').text(data.admin_password)
              )
            )
          );
        
        $credentialsContainer.empty().append($credBox);
        $btn.hide(); // Hide reveal button after showing credentials
      },
      error: function(xhr) {
        const message = xhr.responseJSON?.error || 'Failed to retrieve credentials';
        
        $credentialsContainer
          .empty()
          .append(
            $('<div>')
              .addClass('alert alert-danger')
              .text(message)
          );
        
        $btn.prop('disabled', false).text('View Credentials');
      }
    });
  });
});

// Refresh WordPress card state from server
function refreshWordPressCard(domainId) {
  const $card = $(`.wordpress-card[data-domain-id="${domainId}"]`);
  if ($card.length === 0) return;
  
  const statusUrl = $card.data('status-url');
  
  $.ajax({
    url: statusUrl,
    method: 'GET',
    success: function(data) {
      // Replace card content with fresh state
      const wordpress = data.wordpress;
      updateWordPressCardUI($card, wordpress, domainId);
    },
    error: function() {
      // Silently fail - don't disrupt user experience
      console.error('Failed to refresh WordPress card for domain', domainId);
    }
  });
}

// Update WordPress card UI based on state
function updateWordPressCardUI($card, wordpress, domainId) {
  const $cardBody = $card.find('.card-body');
  $cardBody.empty();
  
  if (wordpress.state === 'installable') {
    $cardBody.append(
      $('<button>')
        .addClass('btn btn-primary wordpress-install-btn')
        .attr('data-domain-id', domainId)
        .text('Install WordPress')
    );
  } else if (wordpress.state === 'queued' || wordpress.state === 'installing') {
    $cardBody.append(
      $('<div>').addClass('alert alert-info mb-0').append(
        $('<div>').addClass('d-flex align-items-center').append(
          $('<div>').addClass('spinner-border spinner-border-sm me-2'),
          $('<div>').text(wordpress.message)
        )
      )
    );
  } else if (wordpress.state === 'installed') {
    $cardBody.append(
      $('<div>').addClass('d-flex gap-2').append(
        $('<a>')
          .attr({href: wordpress.admin_url, target: '_blank', rel: 'noopener noreferrer'})
          .addClass('btn btn-primary')
          .html('<i class="fe fe-external-link me-2"></i>Open WordPress Admin'),
        $('<button>')
          .addClass('btn btn-outline-secondary wordpress-reveal-credentials-btn')
          .attr('data-domain-id', domainId)
          .text('View Credentials')
      ),
      $('<div>').addClass('wordpress-credentials').attr('data-domain-id', domainId)
    );
  } else if (wordpress.state === 'failed') {
    $cardBody.append(
      $('<div>').addClass('alert alert-danger mb-3').html('<i class="fe fe-x-circle me-2"></i>' + wordpress.message),
      $('<button>')
        .addClass('btn btn-primary wordpress-install-btn')
        .attr('data-domain-id', domainId)
        .text('Retry Installation')
    );
  } else if (wordpress.state === 'not_supported') {
    $cardBody.append(
      $('<div>').addClass('alert alert-info mb-0').text(wordpress.message)
    );
  }
}
